import { css } from '@emotion/react'
import { colors, spacing } from 'styles/variables'

export const emptyStateContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: ${spacing(4)};
  text-align: center;
`

export const contentWrapper = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing(4)};
  max-width: 300px;
`

export const imageContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${spacing(-8)};
`

export const emptyImage = css`
  max-width: 600px;
  width: 100%;
  height: auto;
`

export const textContainer = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
  text-align: center;
`

export const titleText = css`
  color: ${colors.white100};
  line-height: 1.3;
`

export const subtitleText = css`
  color: ${colors.white80};
  line-height: 1.4;
` 